import { useEffect, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useAppDispatch, useAppSelector } from 'core/store/hooks';
import { RptSalPlannedFilterDto, SearchSalMeseAnnoRequest } from '@api/client';
import { StorageKeysEnum } from 'enums/storageKeys.enum';
import { getDashboardProjectFilters, getSALPlanning, saveDashboardSalFilters } from 'pages/private/dashboard/_redux/actions';
import { filtersDashboardProjectSelector } from 'pages/private/dashboard/_redux/selectors';

const useFormSalPlanning = (initialData: any) => {
  const dispatch = useAppDispatch();
  const isSubmitting = useRef(false);
  const filters = useAppSelector(filtersDashboardProjectSelector);
  const [chipsFormData, setChipsFormData] = useState<any[]>([]);
  const [filterParams, setFilterParams] = useState<any[]>([]);

  useEffect(() => {
    if (!filters) {
      dispatch(getDashboardProjectFilters());
    }
  }, [dispatch, filters]);

  const { reset, handleSubmit } = useForm({
    mode: 'onChange',
    defaultValues: initialData,
  });

  const onSubmit = (data: any) => {
    sessionStorage.setItem(StorageKeysEnum.CURRENT_PAGE_SAL_PLANNING, String(0));
    isSubmitting.current = true;
    const formDataArray = [];

    for (const key in data) {
      if (data.hasOwnProperty(key)) {
        if (data[key] !== initialData[key]) {
          formDataArray.push([key, data[key]]);
        }
      }
    }

    setFilterParams([...formDataArray]);
    setChipsFormData([...formDataArray]);

    const filtersSal: RptSalPlannedFilterDto = {};

    if (data.dataInvioSalStart) {
      filtersSal.dataInvioSalStart = new Date(data.dataInvioSalStart);
    }
    if (data.dateInvioSalEnd) {
      filtersSal.dateInvioSalEnd = new Date(data.dateInvioSalEnd);
    }
    if (data.pkTipologiaBlocco) {
      filtersSal.pkTipologiaBlocco = data.pkTipologiaBlocco;
    }
    if (data.plUserId) {
      filtersSal.plUserId = data.plUserId;
    }
    if (data.plV2UserId) {
      filtersSal.plV2UserId = data.plV2UserId;
    }
    if (data.idCliente) {
      filtersSal.idCliente = data.idCliente;
    }
    if (data.idStrutturaBusiness) {
      filtersSal.idStrutturaBusiness = data.idStrutturaBusiness;
    }

    const payload: SearchSalMeseAnnoRequest = {
      rptSalPlannedFilterDto: { ...filtersSal },
    };

    dispatch(getSALPlanning(payload))
      .unwrap()
      .then((res: any) => {});

    dispatch(saveDashboardSalFilters(filtersSal));

    handleSubmit(data);
  };

  const onReset = () => {
    reset(initialData);
    setChipsFormData([]);
    setFilterParams([]);
    dispatch(saveDashboardSalFilters({}));
  };

  return { onSubmit, onReset, filterParams, chipsFormData, setChipsFormData, reset };
};

export default useFormSalPlanning;
